import { server_connection } from 'config';
import store from 'store';
import { resetTimer } from 'main/components/timer/store/actions';
import * as NotificationActions from '../../../notification/store/actions';
import { updateUserRoles } from '../../../../../auth/store/actions';

export const SELECT_ANSWER              = '[STUDENT QUIZ] SELECT ANSWER';
export const SET_QUESTION               = '[STUDENT QUIZ] SET QUESTION';
export const CLEAR_STUDENT_ANSWERS      = '[STUDENT QUIZ] CLEAR STUDENT ANSWERS';
export const CREATE_STUDENT_QUIZ_HEADER = '[STUDENT QUIZ] CREATE STUDENT QUIZ HEADER';
export const SET_ATTEMPT                = '[STUDENT QUIZ] SET ATTEMPT';
export const SET_QUIZ_IN_PROGRESS       = '[STUDENT QUIZ] SET QUIZ IN PROGRESS';
export const ORDER_STUDENT_ANSWER       = '[STUDENT QUIZ] ORDER STUDENT ANSWER';
export const INIT_ORDER_ANSWER          = '[STUDENT QUIZ] INIT ORDER ANSWER';

export const GET_COURSE_INFO            = '[STUDENT QUIZ] GET COURSE INFO';

export function selectAnswer(question_id, question_type_id, answer) {
    return (dispatch) => {
        return dispatch({
            type: SELECT_ANSWER,
            payload: { question_id, question_type_id, answer }
        });
    }
}

export function setQuestion(questionIndex) {
    return (dispatch) => {
        const questionListLength = store.getState().quizApp.quizzes.currentQuiz.questionList.length;
        
        return dispatch({
            type: SET_QUESTION,
            payload: { questionIndex, questionListLength }
        })
    }
}

export function clearStudentAnswers() {
    return (dispatch) => {
        return dispatch({
            type: CLEAR_STUDENT_ANSWERS,
        })
    }
}

export function submitStudentAnswers(student_quiz_id, timeTaken, studentAnswers, redirect) {
    return (dispatch) => {
        dispatch(resetTimer());
        
        fetch(server_connection + '/quiz/save_student_answers',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ student_quiz_id, timeTaken, studentAnswers })
            })
            .then((response) => {
                dispatch(NotificationActions.getNotifications(store.getState().auth.user)),
                dispatch(updateUserRoles(store.getState().auth.user.data.auth_id)),
                redirect()
            });
    }
}

export function createStudentQuizHeader(event_id, quiz_id, student_id, auth_id) {    
    return (dispatch) => {
        fetch(server_connection + '/quiz/student/create',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({event_id, quiz_id, student_id, auth_id})
            })
            .then((response) => response.json())
            .then((studentHeaderInfo) => {
                return dispatch({
                    type: CREATE_STUDENT_QUIZ_HEADER,
                    payload: studentHeaderInfo
                })
            });
    }
}

export function getAttemptList(event_id, student_id) {
    return (dispatch) => {
        fetch(server_connection + '/quiz/student/attempt_list',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ event_id, student_id })
            })
            .then((response) => response.json())
            .then((attemptList) => {
                return dispatch({
                    type: SET_ATTEMPT,
                    payload: attemptList
                });
            });
    }
}

export function getAuthAttemptList(quiz_id, auth_id) {
    return (dispatch) => {
        fetch(server_connection + '/quiz/student/auth_attempt_list',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ quiz_id, auth_id })
            })
            .then((response) => response.json())
            .then((attemptList) => {
                return dispatch({
                    type: SET_ATTEMPT,
                    payload: attemptList
                });
            });
    }
}

export function setQuizInProgress(status) {
    return (dispatch) => {
        return dispatch({
            type: SET_QUIZ_IN_PROGRESS,
            payload: status
        })
    }
}

export function initOrderAnswer(question_id, answerList) {
    return (dispatch) => {
        return dispatch({
            type: INIT_ORDER_ANSWER,
            payload: { question_id, answerList }
        })
    }
}

export function orderStudentAnswer(source, destination, question_id) {
    return (dispatch) => {
        return dispatch({
            type: ORDER_STUDENT_ANSWER,
            payload: { source, destination, question_id }
        })
    }
}

export function getCourseInfo(cur_event_id) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/scheduled_course/get_info_for_quiz/' + cur_event_id)
            .then((response) => response.json())
            .then((responseData) => {
                return dispatch({
                    type: GET_COURSE_INFO,
                    payload: responseData
                });
            });
    }
}


// WEBPACK FOOTER //
// src/main/content/quiz/store/actions/quizViewer.actions.js